import {getRootScope, listAccessibleTypes, ScopeChainNode} from "../analysis";
import {BaseTree, IdentTree, ImportDeclarationTree, NameTree} from "../model";
import {Misc, Separator, Token} from "../lexer";
import {Completion, CompletionResult} from "@codemirror/autocomplete";
import {makeCompletionPattern} from "./factory";

function completeImportDeclaration(
	scope: ScopeChainNode,
	left: NameTree,
	current: Token | BaseTree
) {
	const lhs = left.qualifier.referent; // e.g. java
	if (!lhs) return null;

	if (lhs.type === "package") {
		const filter = !(current instanceof BaseTree)
			? ""
			: left.identifier.identifier;
		const packageOptions = [...lhs.subpackages.keys()]
			.filter((x) => x.startsWith(filter))
			.map((x) => {
				return {label: x, type: "package"};
			});
		packageOptions.push(
			...listAccessibleTypes(scope, lhs)
				.filter((x) => x.startsWith(filter))
				.map((x) => {
					return {label: x, type: "class"};
				})
		);
		return {
			from: left.dotToken.span.end,
			options: packageOptions,
		} as CompletionResult;
	}

	return null;
}

const imports1 = makeCompletionPattern(
	[ImportDeclarationTree, NameTree, Separator.Dot] as const,
	(chain, scope, importDecl, left, current) => {
		// EXAMPLE: java.lan|
		return completeImportDeclaration(scope, left, current);
	}
);

const imports2 = makeCompletionPattern(
	[ImportDeclarationTree, NameTree, IdentTree, Misc.identifier] as const,
	(chain, scope, importDecl, left, ident, current) => {
		// EXAMPLE: java.lan|
		return completeImportDeclaration(scope, left, current);
	}
);

/**
 * import jav|
 */
const imports3 = makeCompletionPattern(
	[ImportDeclarationTree, IdentTree, Misc.identifier] as const,
	(chain, scope, importTree, identTree, identToken) => {
		const rootScope = getRootScope(scope);
		const packages = [...rootScope.packages!.keys()];

		const options = packages
			.filter((name) => name.startsWith(identToken.value))
			.map((name) => ({label: name, type: "package"}) as Completion);

		return {
			from: identToken.span.start,
			options,
		};
	}
);

export const IMPORTS = [imports1, imports2, imports3];
